import { render, staticRenderFns } from "./OnlCgformHeadList.vue?vue&type=template&id=0eb11cca&scoped=true&"
import script from "./OnlCgformHeadList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformHeadList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformHeadList.vue?vue&type=style&index=0&id=0eb11cca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb11cca",
  null
  
)

export default component.exports